import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';

const ImageCropper = ({ image, type, dimension, onCropComplete, onCropCancel }) => {
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    const onCropChange = useCallback((newCrop) => {
        setCrop(newCrop);
      }, []);
    
      const onZoomChange = useCallback((newZoom) => {
        const zoomFactor = 0.1;
        setZoom((prevZoom) => Math.min(Math.max(0.1, prevZoom + (newZoom - prevZoom) * zoomFactor), 3));
      }, []);
  
    const handleCropComplete = useCallback((croppedArea, croppedPixels) => {
        setCroppedAreaPixels(croppedPixels);
    }, []);

    const getCroppedImg = (imageSrc, croppedAreaPixels) => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
      
        const image = new Image();
        image.src = imageSrc;
        
        return new Promise((resolve, reject) => {
          image.onload = () => {
            canvas.width = croppedAreaPixels.width;
            canvas.height = croppedAreaPixels.height;
            ctx.drawImage(
              image,
              croppedAreaPixels.x,
              croppedAreaPixels.y,
              croppedAreaPixels.width,
              croppedAreaPixels.height,
              0,
              0,
              croppedAreaPixels.width,
              croppedAreaPixels.height
            );
            
            canvas.toBlob((blob) => {
              resolve(blob);
            }, 'image/jpeg', 1);
          };
          image.onerror = reject;
        });
    };

    const onConfirm = async () => {
        try {
            const croppedImage = await getCroppedImg(image, croppedAreaPixels);
            onCropComplete(croppedImage, type); // Return cropped image
        } catch (e) {
            console.log(e);
        }
    };

    const onCancel = async () => {
        try {
            onCropCancel();
        } catch (e) {
            console.log(e);
        }
    };

    return (
        <div>
            <Cropper
                image={image}
                crop={crop}
                zoom={zoom}
                aspect={1}
                cropSize={dimension}
                onCropChange={onCropChange}
                onCropComplete={handleCropComplete}
                onZoomChange={onZoomChange}
                minZoom={0.1} 
            />
            <div className="controls" style={{ position: 'absolute', bottom: '30px', right: '30px', zIndex: 10, display: 'flex', justifyContent: 'flex-end' }}>
                <button onClick={onConfirm} className="btn btn-primary mt-3">Crop Image</button>
                <button onClick={onCancel} className="btn btn-secondary mt-3 ms-2">Cancel</button>
            </div>
        </div>
    );
};

export default ImageCropper;
